import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Column, TabsList } from '@pella/sash-framework';
import { Image } from '../../../';
import SlickSlider from '../../../common/slick-slider';
import styles from './index.module.scss';
import { isValidArray } from '../../../utilities/validations';

class Collection extends Component {
	constructor(props) {
		super(props);

		// Loop through tabs and create a state for each tab
		let optionTabs = {};
		if (!props.isSingle) {
			for (let x = 0; x < props.data.length; x++) {
				optionTabs[props.data[x].options_title.toLowerCase().replace(/\s+/g, '-')] = {
					// Remove the strict validation when isSingle prop is working...
					name: props.data[x].options_images && props.data[x].options_images[0] && props.data[x].options_images[0].image_title,
					activeTab: 0,
				};
			}
		}

		this.state = {
			activeIndex: 0,
			...optionTabs,
		};

		this.onImageClick = this.onImageClick.bind(this);
	}

	onImageClick(e) {
		const parent = e.currentTarget.dataset.parent;
		const id = e.currentTarget.dataset.index;
		const name = e.currentTarget.dataset.name;

		this.setState({
			[parent]: {
				activeTab: parseInt(id),
				name: name,
			},
		});
	}

	render() {
		const { title, content, isSingle, isFeature, id, carouselData, data, cta, proData } = this.props;

		return (
			<div className={`${styles.collection} ${isSingle ? styles.collection_SingleImageCollection : ''}`}>
				{
					// Intro for FNO that isn't single or feature
					!isSingle && !isFeature && (
						<Row
							justify='between'
							className={styles.collection_Content}
						>
							<Column xs={12}>
								{title && (
									<h3
										className={styles.collection_Title}
										dangerouslySetInnerHTML={{
											__html: title,
										}}
									/>
								)}
								{content && (
									<div
										className={styles.collection_Intro}
										dangerouslySetInnerHTML={{
											__html: content,
										}}
									/>
								)}
							</Column>
						</Row>
					)
				}

				{
					// Combinations Slider Only
					isValidArray(carouselData) && (
						<SlickSlider
							slidesToShow={3}
							arrows={true}
							dots={false}
							className={styles.collectionCombinations}
							responsive={[
								{
									breakpoint: 900,
									settings: { slidesToShow: 2 },
								},
								{
									breakpoint: 550,
									settings: { slidesToShow: 1 },
								},
							]}
						>
							{carouselData.map((item, index) => (
								<div key={index}>
									<Image
										data={item}
										objectFit='contain'
									/>
									{item.image_title && <p className={styles.collectionCombinations_Name}>{item.image_title}</p>}
								</div>
							))}
						</SlickSlider>
					)
				}

				{
					// If Single Image
					isSingle && !isFeature && (
						<Row
							align='center'
							justify='center'
						>
							<Column
								xs={12}
								md='fluid'
							>
								{title && (
									<h3
										className={styles.collection_Title}
										dangerouslySetInnerHTML={{
											__html: title,
										}}
									/>
								)}
								{content && (
									<div
										className={styles.collection_Intro}
										dangerouslySetInnerHTML={{
											__html: content,
										}}
									/>
								)}
							</Column>

							{isValidArray(data) && (
								<Column
									xs={12}
									md={4}
									lg={3}
								>
									{data.map((option, index) => (
										<div
											key={index}
											className={styles.collection_SingleImageWrapper}
										>
											<Image
												data={option.options_images[0]}
												className={styles.collection_SingleImage}
											/>
										</div>
									))}
								</Column>
							)}
						</Row>
					)
				}

				{
					// Else if Collection of images
					!isSingle && !isFeature && isValidArray(data) && (
						<TabsList
							justify='start'
							className={styles.collection_Tabs}
						>
							{data.map((option, index) => {
								const parent = option.options_title.toLowerCase().replace(/\s+/g, '-');

								return (
									<TabsList.Tab
										key={index}
										title={option.options_title}
									>
										<Row noGutters={true}>
											<Column
												xs={12}
												sm={6}
												md={5}
											>
												<div className={styles.collection_SelectedOption}>
													<Image
														data={option.options_images[this.state[parent].activeTab]}
														className={styles.collection_SelectedOptionImage}
														objectFit='contain'
													/>
													<p className={styles.collection_SelectedOptionTitle}>{this.state[parent].name}</p>
												</div>
											</Column>

											<Column
												xs={12}
												sm={6}
												md={7}
											>
												<div className={styles.collection_SliderWrapper}>
													{option.options_images && option.options_images[0] && (
														<SlickSlider
															dots={true}
															arrows={false}
															slidesToShow={1}
															slidesToSlide={1}
															rows={2}
															slidesPerRow={3}
															responsive={[
																{
																	breakpoint: 790,
																	settings: {
																		slidesPerRow: 3,
																		slidesToShow: 1,
																		rows: 3,
																	},
																},
																{
																	breakpoint: 550,
																	settings: {
																		rows: 1,
																		slidesPerRow: 1,
																		slidesToShow: 3.5,
																		arrows: true,
																		dots: false,
																	},
																},
															]}
														>
															{option.options_images.map((image, index) => (
																<div
																	className={styles.collection_SliderDiv}
																	key={index}
																>
																	<button
																		className={`${styles.collection_Image} ${this.state[parent].activeTab === index ? styles.collection_Image_active : ''}`}
																		onClick={this.onImageClick}
																		data-index={index}
																		data-parent={parent}
																		data-name={image.image_title}
																		aria-label={image.image_title && image.image_title !== '' ? image.image_title : 'collection image'}
																	>
																		<Image
																			data={image}
																			objectFit='contain'
																		/>
																	</button>
																</div>
															))}
														</SlickSlider>
													)}
												</div>
											</Column>
										</Row>

										{(option.pro_tips?.heading || option.pro_tips?.description) && (
											<div className={styles.collection_Pro}>
												<Row align='center'>
													<Column
														xs={12}
														md={!option.pro_tips.image?.[0] ? 12 : 6}
													>
														{option.pro_tips.heading && (
															<div
																className={styles.collection_ProHeading}
																dangerouslySetInnerHTML={{
																	__html: option.pro_tips.heading,
																}}
															/>
														)}

														{option.pro_tips.description && (
															<div
																className={styles.collection_ProContent}
																dangerouslySetInnerHTML={{
																	__html: option.pro_tips.description,
																}}
															/>
														)}
													</Column>

													{option.pro_tips.image?.[0] && (
														<Column
															xs={12}
															md={6}
														>
															<Row justify='center'>
																{option.pro_tips.image.map((img, index) => (
																	<Column
																		xs={4}
																		key={index}
																		className={styles.collection_ProImageCol}
																	>
																		<Image data={img} />
																		<p className={styles.collection_ProImageTitle}>{img.image_title}</p>
																	</Column>
																))}
															</Row>
														</Column>
													)}
												</Row>
											</div>
										)}
									</TabsList.Tab>
								);
							})}
						</TabsList>
					)
				}

				{isValidArray(proData) && (
					<div className={styles.collection_Pro}>
						<Row align='center'>
							<Column
								xs={12}
								md={!proData[0].image || (proData[0].image && !proData[0].image[0]) ? 12 : 6}
							>
								{proData[0].heading && (
									<div
										className={styles.collection_ProHeading}
										dangerouslySetInnerHTML={{
											__html: proData[0].heading,
										}}
									/>
								)}
								{proData[0].subheading && (
									<div
										className={styles.collection_ProSubheading}
										dangerouslySetInnerHTML={{
											__html: proData[0].subheading,
										}}
									/>
								)}

								{proData[0].description && (
									<div
										className={styles.collection_ProContent}
										dangerouslySetInnerHTML={{
											__html: proData[0].description,
										}}
									/>
								)}
							</Column>

							{proData[0].image && proData[0].image[0] && (
								<Column
									xs={12}
									md={6}
								>
									<Row justify='center'>
										{proData[0].image.map((img, index) => (
											<Column
												xs={4}
												key={index}
												className={styles.collection_ProImageCol}
											>
												<Image data={img} />
												<p className={styles.collection_ProImageTitle}>{img.image_title}</p>
											</Column>
										))}
									</Row>
								</Column>
							)}
						</Row>
					</div>
				)}
			</div>
		);
	}
}

Collection.propTypes = {
	data: PropTypes.array,
	title: PropTypes.string,
	content: PropTypes.string,
	isSingle: PropTypes.bool,
	isFeature: PropTypes.bool,
	id: PropTypes.number,
	carouselData: PropTypes.array,
	proData: PropTypes.array,
	cta: PropTypes.array,
};

export default Collection;
